"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplitudeFlagKey = exports.AmplitudeVariantValue = exports.AmplitudeEventKeys = void 0;
var AmplitudeEventKeys;
(function (AmplitudeEventKeys) {
    AmplitudeEventKeys["ClickSlippingAwayReport"] = "CLICK-SLIPPING-AWAY-REPORT";
    AmplitudeEventKeys["ClickVisitorReport"] = "CLICK-VISITOR-REPORT";
    AmplitudeEventKeys["ClickChurnedReport"] = "CLICK-CHURN-REPORT";
})(AmplitudeEventKeys || (exports.AmplitudeEventKeys = AmplitudeEventKeys = {}));
var AmplitudeVariantValue;
(function (AmplitudeVariantValue) {
    AmplitudeVariantValue["OFF"] = "off";
    AmplitudeVariantValue["CONTROL"] = "control";
    AmplitudeVariantValue["A"] = "a";
    AmplitudeVariantValue["B"] = "b";
    AmplitudeVariantValue["C"] = "c";
})(AmplitudeVariantValue || (exports.AmplitudeVariantValue = AmplitudeVariantValue = {}));
// Key needs to be lowercase only
var AmplitudeFlagKey;
(function (AmplitudeFlagKey) {
    AmplitudeFlagKey["FamilyGroupMembership"] = "family-group-membership";
    AmplitudeFlagKey["MembershipCampaignReplacement"] = "membership-campaign-replacement";
    AmplitudeFlagKey["MfaMandatoryForBankPermissionUsers"] = "mfa-mandatory-for-bank-permission-users";
    AmplitudeFlagKey["PostMailPcmProvider"] = "post-mail-pcm-provider";
    AmplitudeFlagKey["SuggestedAmountsTest"] = "suggested-amounts-test";
    AmplitudeFlagKey["DelightfulErLiveFormExperiment"] = "delightful-er-live-experiment";
    AmplitudeFlagKey["CustomColorTileExperiment"] = "live-form-custom-color-tile";
    AmplitudeFlagKey["CampaignTotalsHub"] = "campaign-totals-hub";
    AmplitudeFlagKey["CampaignTotalsFormVolume"] = "campaign-totals-form-volume";
    AmplitudeFlagKey["OnDemandPayoutEligible"] = "on-demand-payout-eligible";
    AmplitudeFlagKey["OnDemandPayoutRequestAccess"] = "on-demand-payout-request-access";
    AmplitudeFlagKey["MagicEmailFlow"] = "magic-email-flow";
    AmplitudeFlagKey["AiImportValidation"] = "ai-import-validation";
    AmplitudeFlagKey["AddOns"] = "add-ons";
    /** Communication Preferences in the form editor. Variant "b" = the question is offered in the answer-format picker. */
    AmplitudeFlagKey["CommunicationPreferences"] = "communication-preferences";
    AmplitudeFlagKey["AiDescriptionWizard"] = "ai-description-wizard";
    AmplitudeFlagKey["AuctionExpressCheckout"] = "auction-express-checkout";
    AmplitudeFlagKey["DonorAssistantWidget"] = "donor-assistant-widget";
    AmplitudeFlagKey["OrganizationAssistantWidget"] = "organization-assistant-widget";
    AmplitudeFlagKey["EventFeatureBanners"] = "event-feature-banners";
    AmplitudeFlagKey["EventCheckinPushNotif"] = "event-checkin-push-notif";
    AmplitudeFlagKey["CashAppPaymentMethod"] = "cashapp-payment-method";
    AmplitudeFlagKey["DonationProcessingDay"] = "donation-processing-day";
    AmplitudeFlagKey["CrossSellNewOrgs"] = "cross-sell-new-orgs";
})(AmplitudeFlagKey || (exports.AmplitudeFlagKey = AmplitudeFlagKey = {}));
